export default __webpack_public_path__ + "static/media/login.f70d86f6.png";